import { API } from "@project/shared";

const getNewsLists = () => {
  return API.get("/user/news");
};

export { getNewsLists };
